// import React, { useState } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import LeftImage from "../../assets/Images/signup.jpg";
// import wlogo from "../../assets/Images/White_TCL_logo.png";
// import "./signup.css";

// const Spinner = () => <div className="loader" style={{ margin: "auto" }}></div>;

// function SignUp() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     password: "",
//     confirmPassword: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [passwordsMatch, setPasswordsMatch] = useState(true);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();

//   const togglePasswordVisibility = () => setShowPassword(!showPassword);
//   const toggleConfirmPasswordVisibility = () => setShowConfirmPassword(!showConfirmPassword);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     let isValid = true;

//     if (name === "email") {
//       const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//       isValid = emailRegex.test(value);
//     }

//     if (name === "phone") {
//       const phoneRegex = /^[0-9]+$/;
//       isValid = phoneRegex.test(value);
//     }

//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       [name]: value,
//     }));

//     if (name === "confirmPassword") {
//       setPasswordsMatch(formData.password === value);
//     }

//     if (!isValid) {
//       setErrors((prevErrors) => ({
//         ...prevErrors,
//         [name]: `Invalid ${name}`,
//       }));
//     } else {
//       setErrors((prevErrors) => ({
//         ...prevErrors,
//         [name]: "",
//       }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     if (formData.password !== formData.confirmPassword) {
//       toast.error("Passwords do not match!");
//       setPasswordsMatch(false);
//       setLoading(false);
//       return;
//     }

//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}registration`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       });

//       const data = await response.json();

//       if (!response.ok || data.status === "false") {
//         toast.error(data.message || "An error occurred during registration.");
//         setLoading(false);
//         return;
//       }

//       toast.success("Registration successful! Redirecting...");
//       sessionStorage.setItem("token", data.token);
//       setTimeout(() => navigate("/otp"), 2000);
//     } catch (error) {
//       toast.error("An error occurred. Please try again later.");
//     } finally {
//       setLoading(false);
//       setFormData({
//         name: "",
//         email: "",
//         phone: "",
//         password: "",
//         confirmPassword: "",
//       });
//     }
//   };

//   return (
//     <>
//       {/* Conditionally render the spinner when loading is true */}
//       {loading && (
//         <div className="loader-container">
//           <div className="loader"></div>
//         </div>
//       )}
//       <ToastContainer />
//       <div className="container-fluid">
//         <div className="row m-0">
//           <div className="col-lg-5 p-0 d-none d-lg-block">
//             <div
//               className="w-100 h-100"
//               style={{
//                 backgroundImage: `url(${LeftImage})`,
//                 backgroundSize: "100% 100%",
//                 // webkitBackdropFilter: "blur(10px)",
//               }}
//             >
//               <div
//                 className="ms-3"
//                 style={{ cursor: "pointer", color: "#FFFFFF" }}
//                 onClick={() => {
//                   window.location.href = "/";
//                 }}
//               >
//                 <img src={wlogo} className="d-none d-md-block" width="185" alt="" />


//               </div>

//               <div className="h-75 d-flex justify-content-center align-items-center">
//                 <h4 style={{ color: "#FFFFFF" }}>
//                   <b>LADAKH</b>
//                 </h4>
//               </div>
//             </div>
//           </div>
//           <div
//             className="col-lg-7 "
//             style={{ backgroundColor: "#03045E", height: "100vh" }}
//           >
//             {/* <img src={wlogo} className="d-block d-md-none" width="120" alt="" /> */}
//             <div className="h-100 d-flex align-items-center justify-content-center">

// {/* Logo for smaller screens positioned on the top right */}
// <div className="d-block d-md-none position-absolute top-0 start-0 m-3" onClick={() => {
//                   window.location.href = "/";
//                 }}>
//   <img src={wlogo} width="150" alt="Logo" />
// </div>
//               <div
//                 className="card mx-2 custom-card"
//                 style={{ maxheight: "550px", borderRadius: "20px" }}
//               >
//                 <div className="card-body px-2 px-md-5 py-1 py-md-4">
//                   <h2 className="card-title mt-3">SIGN UP</h2>
//                   <p className="text-muted pb-3" style={{ fontSize: "medium" }}>
//                     Join us and start your journey today - sign up in seconds!
//                   </p>
//                   <form onSubmit={handleSubmit}>
//                     <div className="mb-3">
//                       <input
//                         type="text"
//                         name="name"
//                         placeholder="Full Name"
//                         value={formData.name}
//                         onChange={handleChange}
//                         className="form-control"
//                         required
//                       />
//                       {errors.name && (
//                         <small className="text-danger">{errors.name}</small>
//                       )}
//                     </div>
//                     <div className="mb-3">
//                       <input
//                         type="text"
//                         name="email"
//                         placeholder="Email"
//                         value={formData.email}
//                         onChange={handleChange}
//                         className="form-control"
//                         required
//                       />
//                       {errors.email && (
//                         <small className="text-danger">{errors.email}</small>
//                       )}
//                     </div>
//                     <div className="mb-3">
//                       <input
//                         type="text"
//                         name="phone"
//                         placeholder="Phone Number"
//                         value={formData.phone}
//                         onChange={handleChange}
//                         className="form-control"
//                         required
//                       />
//                       {errors.phone && (
//                         <small className="text-danger">{errors.phone}</small>
//                       )}
//                     </div>
//                     <div className="mb-3">
//                       <div className="input-group">
//                         <input
//                           type={showPassword ? "text" : "password"}
//                           name="password"
//                           placeholder="Password"
//                           value={formData.password}
//                           onChange={handleChange}
//                           className="form-control"
//                           required
//                         />
//                         <button
//                           type="button"
//                           className="btn btn-outline-secondary"
//                           onClick={togglePasswordVisibility}
//                         >
//                           {showPassword ? "Hide" : "Show"}
//                         </button>
//                       </div>
//                     </div>
//                     <div className="mb-3">
//                       <div className="input-group">
//                         <input
//                           type={showConfirmPassword ? "text" : "password"}
//                           name="confirmPassword"
//                           placeholder="Confirm Password"
//                           value={formData.confirmPassword}
//                           onChange={handleChange}
//                           className="form-control"
//                           required
//                         />
//                         <button
//                           type="button"
//                           className="btn btn-outline-secondary"
//                           onClick={toggleConfirmPasswordVisibility}
//                         >
//                           {showConfirmPassword ? "Hide" : "Show"}
//                         </button>
//                       </div>
//                       {!passwordsMatch && (
//                         <small className="text-danger">
//                           Passwords do not match
//                         </small>
//                       )}
//                     </div>
//                     <div className="mb-3">
//                       <p>
//                         <input
//                           type="checkbox"
//                           name="agreed"
//                           checked={true}
//                           disabled
//                           className="form-check-input"
//                         />
//                         &nbsp;I agree to the{" "}
//                         <Link
//                           to="/terms"
//                           target="_blank"
//                           style={{
//                             textDecoration: "none",
//                             color: "#03045E",
//                             fontWeight: "bold",
//                           }}
//                         >
//                           Terms & Condition
//                         </Link>{" "}
//                         and{" "}
//                         <Link
//                           to="/privacy"
//                           target="_blank"
//                           style={{
//                             textDecoration: "none",
//                             color: "#03045E",
//                             fontWeight: "bold",
//                           }}
//                         >
//                           Privacy Policy
//                         </Link>
//                       </p>
//                     </div>
//                     <div className="text-center">
//                       <button
//                         type="submit"
//                         className="btn mt-1"
//                         style={{
//                           borderRadius: "20px",
//                           backgroundColor: "#03045E",
//                           color: "white",
//                         }}
//                       >
//                         Register{" "}
//                       </button>
//                     </div>
//                   </form>
//                   <p className="text-center mt-3 mb-3">
//                     Already have an account?{" "}
//                     <span className="text-center m-0">
//                       <Link
//                         to="/Login"
//                         style={{
//                           textDecoration: "none",
//                           color: "#03045E",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         Login Now
//                       </Link>
//                     </span>
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default SignUp;





// import React, { useState } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import LeftImage from "../../assets/Images/signup.jpg";
// import wlogo from "../../assets/Images/White_TCL_logo.png";
// import "./signup.css";

// const Spinner = () => <div className="loader" style={{ margin: "auto" }}></div>;

// function SignUp() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     password: "",
//     confirmPassword: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [passwordsMatch, setPasswordsMatch] = useState(true);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();

//   const togglePasswordVisibility = () => setShowPassword(!showPassword);
//   const toggleConfirmPasswordVisibility = () =>
//     setShowConfirmPassword(!showConfirmPassword);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     let isValid = true;

//     if (name === "email") {
//       const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//       isValid = emailRegex.test(value);
//     }

//     if (name === "phone") {
//       const phoneRegex = /^[0-9]+$/;
//       isValid = phoneRegex.test(value);
//     }

//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       [name]: value,
//     }));

//     if (name === "confirmPassword") {
//       setPasswordsMatch(formData.password === value);
//     }

//     if (!isValid) {
//       setErrors((prevErrors) => ({
//         ...prevErrors,
//         [name]: `Invalid ${name}`,
//       }));
//     } else {
//       setErrors((prevErrors) => ({
//         ...prevErrors,
//         [name]: "",
//       }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     if (formData.password !== formData.confirmPassword) {
//       toast.error("Passwords do not match!");
//       setPasswordsMatch(false);
//       setLoading(false);
//       return;
//     }

//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}registration`,
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(formData),
//         }
//       );

//       const data = await response.json();
//       console.log("data",data);
//       if (!response.ok || data.status === "false") {
//         toast.error(data.message || "An error occurred during registration.");
//         setLoading(false);
//         return;
//       }

//       toast.success("Registration successful! Redirecting...");
//       sessionStorage.setItem("token", data.token);
//       setTimeout(() => navigate("/otp"), 2000);
//     } catch (error) {
//       toast.error("An error occurred. Please try again later.");
//     } finally {
//       setLoading(false);
//       setFormData({
//         name: "",
//         email: "",
//         phone: "",
//         password: "",
//         confirmPassword: "",
//       });
//     }
//   };

//   return (
//     <>
//       {loading && (
//         <div className="loader-container">
//           <div className="loader"></div>
//         </div>
//       )}
//       <ToastContainer />
//       <div className="container-fluid">
//         <div className="row m-0" style={{ height: "100vh" }}>
//           {/* Left Image Column */}
//           <div className="col-lg-6 p-0">
//             <div
//               className="w-100 h-100"
//               style={{
//                 backgroundImage: `url(${LeftImage})`,
//                 backgroundSize: "cover",
//                 backgroundPosition: "center",
//               }}
//             >
//               <div
//                 className="ms-3 "
//                 style={{ cursor: "pointer" }}
//                 onClick={() => (window.location.href = "/")}
//               >
//                 <img src={wlogo} width="180" alt="Logo" />
//               </div>
//               <div className="h-75 d-flex justify-content-center align-items-center">
//                 <h1 className="text-white"><b>LADAKH</b></h1>
//               </div>
//             </div>
//           </div>

//           {/* Right Form Column */}
//           <div
//   className="col-lg-6 d-flex justify-content-center align-items-center"
//   style={{
//     position: "relative",
//     overflow: "hidden", // Prevent scrollbars from the absolute image
//   }}
// >
//   {/* Blurred Background Image */}
//   <div
//     style={{
//       backgroundImage: `url(${LeftImage})`,
//       backgroundSize: "cover",
//       backgroundPosition: "center",
//       filter: "blur(10px)",
//       position: "absolute",
//       top: 0,
//       left: 0,
//       width: "100%",
//       height: "100%",
//       zIndex: 0,
//     }}
//   />

//   {/* Form Container (Glassmorphic) */}
//   <div
//     className="glassmorphic-card p-4"
//     style={{
//       position: "relative",
//       zIndex: 1,
//       backdropFilter: "blur(12px)",
//       background: "rgba(255, 255, 255, 0.1)",
//       border: "1px solid rgba(255, 255, 255, 0.2)",
//       borderRadius: "20px",
//       width: "90%",
//       maxWidth: "500px",
//     }}
//   >
//               <div className="card-body px-3 px-md-4 py-2 py-md-4 text-white">
//                 <h2 className="card-title">SIGN UP</h2>
//                 <p className="text-light mb-4" style={{ fontSize: "medium" }}>
//                   Join us and start your journey today - sign up in seconds!
//                 </p>

//                 <form onSubmit={handleSubmit}>
//                   <div className="mb-3">
//                     <input
//                       type="text"
//                       name="name"
//                       placeholder="Full Name"
//                       value={formData.name}
//                       onChange={handleChange}
//                       className="form-control"
//                       required
//                     />
//                     {errors.name && (
//                       <small className="text-danger">{errors.name}</small>
//                     )}
//                   </div>
//                   <div className="mb-3">
//                     <input
//                       type="text"
//                       name="email"
//                       placeholder="Email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       className="form-control"
//                       required
//                     />
//                     {errors.email && (
//                       <small className="text-danger">{errors.email}</small>
//                     )}
//                   </div>
//                   <div className="mb-3">
//                     <input
//                       type="text"
//                       name="phone"
//                       placeholder="Phone Number"
//                       value={formData.phone}
//                       onChange={handleChange}
//                       className="form-control"
//                       required
//                     />
//                     {errors.phone && (
//                       <small className="text-danger">{errors.phone}</small>
//                     )}
//                   </div>
//                   <div className="mb-3">
//                     <div className="input-group">
//                       <input
//                         type={showPassword ? "text" : "password"}
//                         name="password"
//                         placeholder="Password"
//                         value={formData.password}
//                         onChange={handleChange}
//                         className="form-control"
//                         required
//                       />
//                       <button
//                         type="button"
//                         className="btn btn-outline-light"
//                         onClick={togglePasswordVisibility}
//                       >
//                         {showPassword ? "Hide" : "Show"}
//                       </button>
//                     </div>
//                   </div>
//                   <div className="mb-3">
//                     <div className="input-group">
//                       <input
//                         type={showConfirmPassword ? "text" : "password"}
//                         name="confirmPassword"
//                         placeholder="Confirm Password"
//                         value={formData.confirmPassword}
//                         onChange={handleChange}
//                         className="form-control"
//                         required
//                       />
//                       <button
//                         type="button"
//                         className="btn btn-outline-light"
//                         onClick={toggleConfirmPasswordVisibility}
//                       >
//                         {showConfirmPassword ? "Hide" : "Show"}
//                       </button>
//                     </div>
//                     {!passwordsMatch && (
//                       <small className="text-danger">
//                         Passwords do not match
//                       </small>
//                     )}
//                   </div>
//                   <div className="mb-3">
//                     <p>
//                       <input
//                         type="checkbox"
//                         name="agreed"
//                         checked={true}
//                         disabled
//                         className="form-check-input"
//                       />
//                       &nbsp;I agree to the{" "}
//                       <Link
//                         to="/terms"
//                         target="_blank"
//                         style={{
//                           textDecoration: "none",
//                           color: "#00B4D8",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         Terms & Condition
//                       </Link>{" "}
//                       and{" "}
//                       <Link
//                         to="/privacy"
//                         target="_blank"
//                         style={{
//                           textDecoration: "none",
//                           color: "#00B4D8",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         Privacy Policy
//                       </Link>
//                     </p>
//                   </div>
//                   <div className="text-center">
//                     <button
//                       type="submit"
//                       className="btn mt-1"
//                       style={{
//                         borderRadius: "20px",
//                         backgroundColor: "#00B4D8",
//                         color: "white",
//                       }}
//                     >
//                       Register
//                     </button>
//                   </div>
//                 </form>
//                 <p className="text-center mt-3 mb-0 text-light">
//                   Already have an account?{" "}
//                   <Link
//                     to="/Login"
//                     style={{ textDecoration: "none", color: "#00B4D8", fontWeight: "bold" }}
//                   >
//                     Login Now
//                   </Link>
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default SignUp;


import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeftImage from "../../assets/Images/signup.jpg";
import wlogo from "../../assets/Images/White_TCL_logo.png";
import "./signup.css";
import Seo from "../Seo/Seo";
import { useSeoMeta } from "../Seo/useSeoMeta";

const Spinner = () => <div className="loader" style={{ margin: "auto" }}></div>;

function SignUp() {
  const centralizedSeo = useSeoMeta();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const toggleConfirmPasswordVisibility = () =>
    setShowConfirmPassword(!showConfirmPassword);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let isValid = true;

    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      isValid = emailRegex.test(value);
    }

    if (name === "phone") {
      const phoneRegex = /^[0-9]+$/;
      isValid = phoneRegex.test(value);
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    if (name === "confirmPassword") {
      setPasswordsMatch(formData.password === value);
    }

    if (!isValid) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: `Invalid ${name}`,
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match!");
      setPasswordsMatch(false);
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}registration`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();
      console.log("data",data);
      if (!response.ok || data.status === "false") {
        toast.error(data.message || "An error occurred during registration.");
        setLoading(false);
        return;
      }

      toast.success("Registration successful! Redirecting...");
      sessionStorage.setItem("token", data.token);
      setTimeout(() => navigate("/otp"), 2000);
    } catch (error) {
      toast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
      setFormData({
        name: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
      });
    }
  };

  return (
    <>
      <Seo title="Sign Up | Traveller Choice Ladakh" noindex centralizedSeo={centralizedSeo} />
      <style>
        {`
          /* Mobile devices (up to 768px) */
          @media (max-width: 767.98px) {
            .signup-container {
              height: 100vh !important;
              background-image: url(${LeftImage}) !important;
              background-size: cover !important;
              background-position: center !important;
              background-repeat: no-repeat !important;
            }
            
            .left-image-section {
              display: none !important;
            }
            
            .right-form-section {
              width: 100% !important;
              height: 100vh !important;
              padding: 1rem !important;
              background: none !important;
            }
            
            .mobile-background-overlay {
              position: absolute !important;
              top: 0 !important;
              left: 0 !important;
              width: 100% !important;
              height: 100% !important;
              background: rgba(0, 0, 0, 0.4) !important;
              z-index: 0 !important;
            }
            
            .glassmorphic-card {
              width: 100% !important;
              max-width: none !important;
              margin: 1rem 0 !important;
              position: relative !important;
              z-index: 2 !important;
            }
            
            .logo-mobile {
              position: absolute !important;
              top: 1rem !important;
              left: 1rem !important;
              z-index: 10 !important;
            }
            
            .logo-mobile img {
              width: 120px !important;
            }
          }
          
          /* Tablet devices (768px to 991.98px) */
          @media (min-width: 768px) and (max-width: 991.98px) {
            .glassmorphic-card {
              width: 95% !important;
            }
            
            .signup-container {
              height: 100vh;
            }
            
            .left-image-section,
            .right-form-section {
              height: 100vh;
            }
          }
          
          /* Desktop styles */
          @media (min-width: 992px) {
            .signup-container {
              height: 100vh;
            }
            
            .left-image-section,
            .right-form-section {
              height: 100vh;
            }
          }
        `}
      </style>

      {loading && (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
      <ToastContainer />
      
      <div className="container-fluid">
        <div className="row m-0 signup-container">
          {/* Left Image Column - Hidden on mobile */}
          <div className="col-12 col-lg-6 p-0 d-none d-lg-block">
            <div
              className="w-100 h-100 left-image-section"
              style={{
                backgroundImage: `url(${LeftImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
              }}
            >
              <div
                className="logo-mobile"
                style={{ cursor: "pointer" }}
                onClick={() => (window.location.href = "/")}
              >
                <img src={wlogo} width="180" alt="Logo" className="img-fluid" />
              </div>
              <div className="h-75 d-flex justify-content-center align-items-center">
                <h1 className="text-white ladakh-text"><b>LADAKH</b></h1>
              </div>
            </div>
          </div>

          {/* Right Form Column */}
          <div
            className="col-12 col-lg-6 d-flex justify-content-center align-items-center right-form-section"
            style={{
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Mobile Background Overlay */}
            <div className="mobile-background-overlay d-block d-lg-none"></div>

            {/* Logo for Mobile */}
            <div
              className="logo-mobile d-block d-lg-none"
              style={{ cursor: "pointer" }}
              onClick={() => (window.location.href = "/")}
            >
              <img src={wlogo} width="120" alt="Logo" className="img-fluid" />
            </div>

            {/* Blurred Background Image - Desktop only */}
            <div
              className="d-none d-lg-block"
              style={{
                backgroundImage: `url(${LeftImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                filter: "blur(10px)",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 0,
              }}
            />

            {/* Form Container (Glassmorphic) */}
            <div
              className="glassmorphic-card p-3 p-md-4"
              style={{
                position: "relative",
                zIndex: 1,
                backdropFilter: "blur(12px)",
                background: "rgba(255, 255, 255, 0.1)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRadius: "20px",
                width: "90%",
                maxWidth: "500px",
              }}
            >
              <div className="card-body px-2 px-md-4 py-2 py-md-4 ">
                <h2 className="card-title text-center text-md-start" style={{color:"#03045E"}}>SIGN UP</h2>
                <p className="text-light mb-3 mb-md-4 text-center text-md-start" style={{ fontSize: "medium" }}>
                  Join us and start your journey today - sign up in seconds!
                </p>

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <input
                      type="text"
                      name="name"
                      placeholder="Full Name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control"
                      style={{ fontSize: "14px" }}
                      required
                    />
                    {errors.name && (
                      <small className="text-danger">{errors.name}</small>
                    )}
                  </div>
                  
                  <div className="mb-3">
                    <input
                      type="text"
                      name="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control"
                      style={{ fontSize: "14px" }}
                      required
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </div>
                  
                  <div className="mb-3">
                    <input
                      type="text"
                      name="phone"
                      placeholder="Phone Number"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-control"
                      style={{ fontSize: "14px" }}
                      required
                    />
                    {errors.phone && (
                      <small className="text-danger">{errors.phone}</small>
                    )}
                  </div>
                  
                  <div className="mb-3">
                    <div className="input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Password"
                        value={formData.password}
                        onChange={handleChange}
                        className="form-control"
                        style={{ fontSize: "14px" }}
                        required
                      />
                      <button
                        type="button"
                        className="btn btn-outline-light btn-sm"
                        onClick={togglePasswordVisibility}
                        style={{ fontSize: "12px" }}
                      >
                        {showPassword ? "Hide" : "Show"}
                      </button>
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <div className="input-group">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        name="confirmPassword"
                        placeholder="Confirm Password"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        className="form-control"
                        style={{ fontSize: "14px" }}
                        required
                      />
                      <button
                        type="button"
                        className="btn btn-outline-light btn-sm"
                        onClick={toggleConfirmPasswordVisibility}
                        style={{ fontSize: "12px" }}
                      >
                        {showConfirmPassword ? "Hide" : "Show"}
                      </button>
                    </div>
                    {!passwordsMatch && (
                      <small className="text-danger">
                        Passwords do not match
                      </small>
                    )}
                  </div>
                  
                  <div className="mb-3">
                    <p className="small">
                      <input
                        type="checkbox"
                        name="agreed"
                        checked={true}
                        disabled
                        className="form-check-input me-2"
                      />
                      I agree to the{" "}
                      <Link
                        to="/terms"
                        target="_blank"
                        style={{
                          textDecoration: "none",
                          color:"#03045E",
                          fontWeight: "bold",
                        }}
                      >
                        Terms & Condition
                      </Link>{" "}
                      and{" "}
                      <Link
                        to="/privacy"
                        target="_blank"
                        style={{
                          textDecoration: "none",
                          color:"#03045E",
                          fontWeight: "bold",
                        }}
                      >
                        Privacy Policy
                      </Link>
                    </p>
                  </div>
                  
                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn mt-1 w-100 w-md-auto px-4"
                      style={{
                        borderRadius: "20px",
                        backgroundColor: "#03045E",
                        color: "white",
                      }}
                    >
                      Register
                    </button>
                  </div>
                </form>
                
                <p className="text-center mt-3 mb-0 text-light small">
                  Already have an account?{" "}
                  <Link
                    to="/login"
                    style={{ textDecoration: "none", color: "#03045E", fontWeight: "bold" }}
                  >
                    Login Now
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SignUp;